import { render, staticRenderFns } from "./RecordPreview.vue?vue&type=template&id=bbeecd40&scoped=true"
import script from "./RecordPreview.vue?vue&type=script&lang=js"
export * from "./RecordPreview.vue?vue&type=script&lang=js"
import style0 from "./RecordPreview.vue?vue&type=style&index=0&id=bbeecd40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeecd40",
  null
  
)

export default component.exports